export default function initTabs(containerSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const tabTriggers = container.querySelectorAll('.tab-trigger');
  const tabPanels = container.querySelectorAll('.tab-panel');

  const setActiveTab = (trigger) => {
    tabTriggers.forEach((tab) => {
      tab.setAttribute('aria-selected', 'false');
    });

    tabPanels.forEach((panel) => {
      panel.classList.add('hidden');
    });

    trigger.setAttribute('aria-selected', 'true');
    const targetPanel = document.querySelector(trigger.getAttribute('href'));
    if (targetPanel) {
      targetPanel.classList.remove('hidden');

      const url = new URL(window.location.href);
      url.searchParams.set(
        'activeTab',
        trigger.getAttribute('href').replace('#tab-', '')
      );
      history.replaceState(null, '', url);
    }
  };

  container.addEventListener('click', (event) => {
    const trigger = event.target.closest('.tab-trigger');
    console.log(trigger);
    if (!trigger) return;

    event.preventDefault();
    setActiveTab(trigger);
  });

  const urlParams = new URLSearchParams(window.location.search);
  const activeTab = urlParams.get('activeTab');

  if (activeTab) {
    const targetTrigger = container.querySelector(
      `.tab-trigger[href="#tab-${activeTab}"]`
    );
    if (targetTrigger) {
      setActiveTab(targetTrigger);
      return;
    }
  }

  if (tabTriggers.length > 0) {
    setActiveTab(tabTriggers[0]);
  }
}
